import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import Sidebar from './Sidebar.jsx';
import Header from './Header.jsx';
import InstallBanner from '../shared/InstallBanner.jsx';
import HelpButton from '../shared/HelpButton.jsx';
import FileViewer from '../shared/FileViewer.jsx';
import OnboardingWizard from '../shared/OnboardingWizard.jsx';
import ForcePasswordChange from '../shared/ForcePasswordChange.jsx';
import { sidebarOpen, toggleSidebar } from '../../state/ui.js';
import { authState } from '../../state/auth.js';

function OfflineBar() {
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    const go = () => setOnline(true);
    const stop = () => setOnline(false);
    window.addEventListener('online', go);
    window.addEventListener('offline', stop);
    return () => { window.removeEventListener('online', go); window.removeEventListener('offline', stop); };
  }, []);

  if (online) return null;

  return (
    <div style="position:fixed;top:0;left:0;right:0;z-index:10000;background:#ef4444;color:#fff;text-align:center;padding:8px 16px;font-size:13px;font-weight:600;display:flex;align-items:center;justify-content:center;gap:8px">
      <span>📡</span> Je bent offline — wijzigingen worden niet opgeslagen
    </div>
  );
}

export default function Shell({ children }) {
  const { onboardingCompleted, isPlatformAdmin, authenticated, mustChangePassword } = authState.value;
  const showWizard = authenticated && !isPlatformAdmin && !onboardingCompleted && !mustChangePassword;

  return (
    <div class="app-layout">
      <OfflineBar />
      <Sidebar />
      <div class={`sidebar-overlay ${sidebarOpen.value ? 'visible' : ''}`} onClick={toggleSidebar} />
      <div class="app-main">
        <Header />
        <main class="app-content">
          {children}
        </main>
      </div>
      <InstallBanner />
      <HelpButton />
      <FileViewer />
      {mustChangePassword && <ForcePasswordChange />}
      {showWizard && <OnboardingWizard />}
    </div>
  );
}
